<template>
  <div ref="container" class="container-fluid im-fluid im-footer" @click="$root.hideMenu">
    <footer class="footer">
      <div class="copyright">
        {{ $t("footer.copyright", { year: currentYear }) }} |
        <router-link to="/contact-us" @click.stop.prevent="$root.gotoContactUs">{{
          $t("nav.contact")
        }}</router-link>
        <template v-if="displayPolicy">
          <br />
          <router-link to="/delivery-policy" @click.stop.prevent="$root.gotoDeliveryPolicy">{{
            $t("footer.delivery_policy")
          }}</router-link>
          |
          <router-link to="/refunds-policy" @click.stop.prevent="$root.gotoRefundsPolicy">{{
            $t("footer.refunds_policy")
          }}</router-link>
        </template>
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: "FooterSection",
    computed: {
      currentYear: function () {
        return new Date().getFullYear();
      },
      displayPolicy() {
        if (this.$root.$assets.countryCode !== "bg") {
          return true;
        }
        return false;
      },
    },
  };
</script>
